module.exports = "<electra-header></electra-header>\n<electra-search-wrapper [ngClass]=\"searchClass\"></electra-search-wrapper>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/headerWrapper/headerWrapper.component.html
// module id = 425
// module chunks = 1